import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import {
    devConfig, // Importing development configuration
    gamesCasino, // Importing casino games configuration
    profile, // Importing user profile configuration
    providersCasino, // Importing casino providers configuration
} from 'config/config'; // Importing configuration from config file

/**
 * Class representing the landing report view for the table.
 * @extends JetView
 */
export default class tableLandingReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            id: 'datatable', // ID for the datatable
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                // Column definitions
                                {
                                    id: 'Id', // Column ID
                                    header: _('Id'), // Column header with localization
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Template', // Column ID
                                    header: _('Plantilla'), // Column header with localization
                                    width: 300, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Partner', // Column ID
                                    header: _('Partner'), // Column header with localization
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IsActivate', // Column ID
                                    header: _('Estado'), // Column header with localization
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') }, // Active option
                                        { id: 'I', value: _('Inactivado') }, // Inactive option
                                    ],
                                    width: 90, // Column width
                                    sort: 'int', // Sorting type
                                },
                                ,
                            ],
                            onClick: {
                                // Event handler for row click
                                edit: function (euv, id) {
                                    var item = this.getItem(id); // Get clicked item
                                    $$('editwinPartnerProducts').show(); // Show edit window
                                    var record = $$('editform').getValues(); // Get values from the edit form
                                    $$('formPartnersEdit').setValue(record.Partners); // Set partners in the form
                                    vthis.app.callEvent('changePartnetsEdit', [{}]); // Trigger event for partner edit change
                                    $$('formCategoriesEdit').setValue(record.CategoriesAdd); // Set categories in the form
                                    vthis.app.callEvent('changeCategoriesEdit', [{}]); // Trigger event for category edit change
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up data loading and event handling.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the datatable
        var url =
            devConfig.geturlApi() + // API URL for data fetching
            'es/LandingPages/GetLandings?Partner=' +
            id_partner +
            '&'; // URL with partner parameter
        var products = []; // Array to hold products
        var filter = ''; // Filter string
        var optionsCategorias = []; // Array for category options
        var vthis = this; // Reference to the current instance
        var popup = ''; // Variable for popup window
        var popupAdd = ''; // Variable for add popup window
        var arrayPartnersAdd = []; // Array for added partners
        var arrayPartnersWithoutAdd = []; // Array for partners without addition
        var arrayPartnersEdit = []; // Array for edited partners
        var arrayPartnersWithoutEdit = []; // Array for partners without edit
        var arrayAdd = []; // Array for added categories
        var arrayWithoutAdd = []; // Array for categories without addition
        var arrayAddEdit = []; // Array for edited categories
        var arrayWithoutAddEdit = []; // Array for categories without edit

        // AJAX request to fetch categories
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(
                devConfig.geturlApi() + 'Categories/GetCategories', // API endpoint
                '{"Partner":"' + id_partner + '"}', // Request body
                {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Error message
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var resp = JSON.parse(text); // Parse response
                        for (var i = 0; i < resp.data.length; i++) {
                            resp.data[i].id = resp.data[i].Id; // Map Id to id
                            resp.data[i].value = resp.data[i].Description; // Map Description to value
                        }
                        optionsCategorias = resp.data; // Set category options
                        popup = webix.ui({
                            // Create edit popup window
                            view: 'window',
                            id: 'editwinPartnerProducts', // ID for the edit window
                            width: screen.width < 500 ? 500 : 650, // Width based on screen size
                            height: screen.width < 500 ? 1100 : 700, // Height based on screen size
                            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
                            head: {
                                view: 'toolbar', // Toolbar for the window header
                                cols: [
                                    {
                                        view: 'label',
                                        label: _('Editar Productos Partner'), // Label for the header
                                    },
                                    {
                                        view: 'icon',
                                        icon: 'wxi-close', // Close icon
                                        click: function () {
                                            this.getTopParentView().hide(); // Hide the window on close
                                        },
                                    },
                                ],
                            },
                            position: 'center', // Center position
                            modal: false, // Non-modal window
                            body: {
                                view: 'scrollview', // Scrollable body
                                scroll: 'xy', // Enable both horizontal and vertical scrolling
                                body: {
                                    view: 'form', // Form for editing partner products
                                    id: 'editform', // ID for the edit form
                                    width: screen.width < 500 ? 500 : 650, // Width based on screen size
                                    height: screen.width < 500 ? 1100 : 1100, // Height based on screen size
                                    elements: [
                                        // Form elements
                                        {
                                            margin: 10,
                                            cols: [
                                                {
                                                    view: 'text', // Text input for Id
                                                    labelPosition: 'top',
                                                    label: 'Id', // Label for Id
                                                    name: 'Id', // Name for the input
                                                    readonly: true, // Read-only input
                                                },
                                                {
                                                    view: 'text', // Text input for Processing Time
                                                    labelPosition: 'top',
                                                    label: _('Tiempo Procesamiento'), // Label with localization
                                                    name: 'ProcessingTime', // Name for the input
                                                    labelWidth: 160, // Label width
                                                    readonly: true, // Read-only input
                                                },
                                            ],
                                        },
                                        {
                                            margin: 10,
                                            cols: [
                                                {
                                                    view: 'text', // Text input for Product
                                                    labelPosition: 'top',
                                                    label: _('Productos'), // Label with localization
                                                    name: 'Product', // Name for the input
                                                    readonly: true, // Read-only input
                                                },
                                                {
                                                    view: 'combo', // Combo input for Provider
                                                    labelPosition: 'top',
                                                    label: _('Proveedor'), // Label with localization
                                                    name: 'ProviderId', // Name for the input
                                                    readonly: true, // Read-only input
                                                },
                                            ],
                                        },
                                        {
                                            margin: 10,
                                            cols: [
                                                {
                                                    view: 'combo', // Combo input for IsActivate
                                                    labelPosition: 'top',
                                                    label: _('Estado'), // Label with localization
                                                    name: 'IsActivate', // Name for the input
                                                    options: [
                                                        // Options for the combo
                                                        {
                                                            id: 'A',
                                                            value: _(
                                                                'Activado', // Active option
                                                            ),
                                                        },
                                                        {
                                                            id: 'I',
                                                            value: _(
                                                                'Inactivado', // Inactive option
                                                            ),
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                        {
                                            margin: 10,
                                            cols: [
                                                {
                                                    view: 'combo', // Combo input for IsVerified
                                                    labelPosition: 'top',
                                                    label: _('Verificado'), // Label with localization
                                                    name: 'IsVerified', // Name for the input
                                                    options: [
                                                        // Options for the combo
                                                        {
                                                            id: 'A',
                                                            value: _(
                                                                'Activado', // Active option
                                                            ),
                                                        },
                                                        {
                                                            id: 'I',
                                                            value: _(
                                                                'Inactivado', // Inactive option
                                                            ),
                                                        },
                                                    ],
                                                },
                                                {
                                                    view: 'combo', // Combo input for FilterCountry
                                                    labelPosition: 'top',
                                                    label: _('Filtro País'), // Label with localization
                                                    name: 'FilterCountry', // Name for the input
                                                    options: [
                                                        // Options for the combo
                                                        {
                                                            id: 'A',
                                                            value: _(
                                                                'Activado', // Active option
                                                            ),
                                                        },
                                                        {
                                                            id: 'I',
                                                            value: _(
                                                                'Inactivado', // Inactive option
                                                            ),
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                        {
                                            margin: 10,
                                            cols: [
                                                {
                                                    view: 'combo', // Combo input for Mobile
                                                    labelPosition: 'top',
                                                    label: _('Mobile'), // Label with localization
                                                    name: 'Mobile', // Name for the input
                                                    options: [
                                                        // Options for the combo
                                                        {
                                                            id: 'S',
                                                            value: _(
                                                                'Activado', // Active option
                                                            ),
                                                        },
                                                        {
                                                            id: 'N',
                                                            value: _(
                                                                'Inactivado', // Inactive option
                                                            ),
                                                        },
                                                    ],
                                                    readonly: true, // Read-only input
                                                },
                                                {
                                                    view: 'combo', // Combo input for Desktop
                                                    labelPosition: 'top',
                                                    label: _('Escritorio'), // Label with localization
                                                    name: 'Desktop', // Name for the input
                                                    options: [
                                                        // Options for the combo
                                                        {
                                                            id: 'S',
                                                            value: _(
                                                                'Activado', // Active option
                                                            ),
                                                        },
                                                        {
                                                            id: 'N',
                                                            value: _(
                                                                'Inactivado', // Inactive option
                                                            ),
                                                        },
                                                    ],
                                                    readonly: true, // Read-only input
                                                },
                                            ],
                                        },
                                        {
                                            margin: 10,
                                            cols: [
                                                {
                                                    view: 'text', // Text input for Maximum
                                                    labelPosition: 'top',
                                                    label: _('Máximo'), // Label with localization
                                                    name: 'Maximum', // Name for the input
                                                    attributes: {
                                                        type: 'number', // Input type
                                                    },
                                                },
                                                {
                                                    view: 'text', // Text input for Minimum
                                                    labelPosition: 'top',
                                                    label: _('Mínimo'), // Label with localization
                                                    name: 'Minimum', // Name for the input
                                                    attributes: {
                                                        type: 'number', // Input type
                                                    },
                                                },
                                            ],
                                        },
                                        {
                                            margin: 10,
                                            cols: [
                                                {
                                                    view: 'text', // Text input for Order
                                                    labelPosition: 'top',
                                                    label: _('Orden'), // Label with localization
                                                    name: 'Order', // Name for the input
                                                    labelWidth: 160, // Label width
                                                    attributes: {
                                                        type: 'number', // Input type
                                                    },
                                                },
                                                {
                                                    view: 'text', // Text input for FeaturedOrder
                                                    labelPosition: 'top',
                                                    label: _('Orden Destacado'), // Label with localization
                                                    name: 'FeaturedOrder', // Name for the input
                                                    labelWidth: 160, // Label width
                                                    attributes: {
                                                        type: 'number', // Input type
                                                    },
                                                },
                                                {
                                                    view: 'text', // Text input for Rows
                                                    labelPosition: 'top',
                                                    label: _('Filas'), // Label with localization
                                                    name: 'Rows', // Name for the input
                                                    labelWidth: 160, // Label width
                                                    attributes: {
                                                        type: 'number', // Input type
                                                    },
                                                },
                                                {
                                                    view: 'text', // Text input for Columns
                                                    labelPosition: 'top',
                                                    label: _('Columnas'), // Label with localization
                                                    name: 'Columns', // Name for the input
                                                    labelWidth: 160, // Label width
                                                    attributes: {
                                                        type: 'number', // Input type
                                                    },
                                                },
                                            ],
                                        },
                                        {
                                            view: 'forminput', // Double list input for Partners Edit
                                            id: 'formPartnersEdit', // ID for the partners edit form
                                            body: {
                                                view: 'dbllist', // Double list view
                                                id: 'dblPartnersEdit', // ID for the double list
                                                list: {
                                                    height: 200, // Height of the list
                                                    scroll: true, // Enable scrolling
                                                },
                                                labelLeft: _(
                                                    'Partners no Seleccionados', // Label for unselected partners
                                                ),
                                                labelRight: _(
                                                    'Partners Seleccionados', // Label for selected partners
                                                ),
                                                data: profile.Partners, // Data for the list
                                            },
                                            labelWidth: 140, // Label width
                                            labelAlign: 'right', // Label alignment
                                        },
                                        {
                                            view: 'forminput', // Double list input for Categories Edit
                                            id: 'formCategoriesEdit', // ID for the categories edit form
                                            body: {
                                                view: 'dbllist', // Double list view
                                                id: 'dbllistEdit', // ID for the double list
                                                list: {
                                                    height: 200, // Height of the list
                                                    scroll: true, // Enable scrolling
                                                },
                                                labelLeft: _(
                                                    'Categorías sin agregar', // Label for unadded categories
                                                ),
                                                labelRight: _(
                                                    'Categorías Producto Partner', // Label for partner product categories
                                                ),
                                                data: optionsCategorias, // Data for the list
                                            },
                                            labelWidth: 140, // Label width
                                            labelAlign: 'right', // Label alignment
                                        },
                                        {
                                            margin: 10,
                                            cols: [
                                                {
                                                    view: 'text', // Text input for Reason
                                                    labelPosition: 'top',
                                                    label: _('Explicación'), // Label with localization
                                                    name: 'Reason', // Name for the input
                                                    labelWidth: 160, // Label width
                                                    attributes: {
                                                        type: 'text', // Input type
                                                    },
                                                },
                                            ],
                                        },
                                        { gravity: 1 }, // Flexible space
                                        {
                                            cols: [
                                                {
                                                    view: 'button', // Cancel button
                                                    value: _('Cancelar'), // Button label with localization
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Hide the window on cancel
                                                    },
                                                },
                                                {
                                                    view: 'button', // Save button
                                                    type: 'form', // Button type
                                                    value: _('Guardar'), // Button label with localization
                                                    click: function ($e) {
                                                        var values = $$('editform').getValues(); // Get values from the edit form
                                                        values.Partners = arrayPartnersEdit; // Set partners in values
                                                        arrayPartnersWithoutEdit = []; // Initialize array for partners without edit
                                                        for (var i = 0; i < profile.Partners.length; i++) {
                                                            var flagPartners = false; // Flag for partner existence
                                                            for (
                                                                var j = 0;
                                                                (j < arrayPartnersEdit.length) & !flagPartners;
                                                                j++
                                                            ) {
                                                                if (profile.Partners[i].id == arrayPartnersEdit[j])
                                                                    flagPartners = true; // Set flag if partner exists
                                                            }
                                                            if (!flagPartners)
                                                                arrayPartnersWithoutEdit.push(
                                                                    profile.Partners[i].id, // Add to partners without edit
                                                                );
                                                        }
                                                        values.PartnersWithoutAdd = arrayPartnersWithoutEdit; // Set partners without addition
                                                        values.CategoriesAdd = arrayAddEdit; // Set categories to add
                                                        arrayWithoutAddEdit = []; // Initialize array for categories without addition
                                                        for (var i = 0; i < optionsCategorias.length; i++) {
                                                            var flag = false; // Flag for category existence
                                                            for (var j = 0; (j < arrayAddEdit.length) & !flag; j++) {
                                                                if (optionsCategorias[i].Id == arrayAddEdit[j])
                                                                    flag = true; // Set flag if category exists
                                                            }
                                                            if (!flag)
                                                                arrayWithoutAddEdit.push(
                                                                    optionsCategorias[i].Id, // Add to categories without addition
                                                                );
                                                        }
                                                        values.CategoriesWithoutAdd = arrayWithoutAddEdit; // Set categories without addition

                                                        // AJAX request to update partner product details
                                                        webix
                                                            .ajax()
                                                            .headers({
                                                                'Content-type': 'application/json', // Set content type
                                                            })
                                                            .post(
                                                                devConfig.geturlApi() +
                                                                    'PartnerProduct/UpdatePartnerProductDetails', // API endpoint
                                                                '{"Id":' +
                                                                    values.Id +
                                                                    ',"IsActivate":"' +
                                                                    values.IsActivate +
                                                                    '","IsVerified":"' +
                                                                    values.IsVerified +
                                                                    '","FilterCountry":"' +
                                                                    values.FilterCountry +
                                                                    '", "Maximum":"' +
                                                                    values.Maximum +
                                                                    '", "Minimum":"' +
                                                                    values.Minimum +
                                                                    '", "Order":"' +
                                                                    values.Order +
                                                                    '", "FeaturedOrder":"' +
                                                                    values.FeaturedOrder +
                                                                    '", "Rows":"' +
                                                                    values.Rows +
                                                                    '", "Columns":"' +
                                                                    values.Columns +
                                                                    '", "Reason":"' +
                                                                    values.Reason +
                                                                    '", "Partners":"' +
                                                                    values.Partners +
                                                                    '", "PartnersWithoutAdd":"' +
                                                                    values.PartnersWithoutAdd +
                                                                    '", "CategoriesAdd":"' +
                                                                    values.CategoriesAdd +
                                                                    '", "CategoriesWithoutAdd":"' +
                                                                    values.CategoriesWithoutAdd +
                                                                    '", "Partner":"' +
                                                                    id_partner +
                                                                    '"}', // Request body
                                                                {
                                                                    error: function (text, data, XmlHttpRequest) {
                                                                        webix.message(
                                                                            'Error! ', // Error message
                                                                        );
                                                                    },
                                                                    success: function (text, data, XmlHttpRequest) {
                                                                        webix.message(
                                                                            'Producto Partner Editado', // Success message
                                                                        );
                                                                        grid.clearAll(); // Clear the grid
                                                                        grid.load(
                                                                            url +
                                                                                '?start=0&count=' +
                                                                                grid.data.$pagesize +
                                                                                filter, // Reload grid data
                                                                        );
                                                                    },
                                                                },
                                                            );
                                                        this.getTopParentView().hide(); // Hide the window after saving
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            },
                        });
                        $$('editform').bind($$('datatable')); // Bind edit form to datatable
                        $$('dblPartnersEdit').attachEvent('onChange', function (id, e, node) {
                            vthis.app.callEvent('changePartnetsEdit', [{}]); // Trigger event for partner edit change
                        });
                        $$('dbllistEdit').attachEvent('onChange', function (id, e, node) {
                            vthis.app.callEvent('changeCategoriesEdit', [{}]); // Trigger event for category edit change
                        });
                        popupAdd = webix.ui({
                            // Create add popup window
                            view: 'window',
                            id: 'AddPartnerProducts', // ID for the add window
                            width: screen.width < 500 ? 500 : 600, // Width based on screen size
                            height: screen.width < 500 ? 1000 : 700, // Height based on screen size
                            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
                            head: {
                                view: 'toolbar', // Toolbar for the window header
                                cols: [
                                    {
                                        view: 'label',
                                        label: _('Añadir Producto Partner'), // Label for the header
                                    },
                                    {
                                        view: 'icon',
                                        icon: 'wxi-close', // Close icon
                                        click: function () {
                                            this.getTopParentView().hide(); // Hide the window on close
                                        },
                                    },
                                ],
                            },
                            position: 'center', // Center position
                            modal: true, // Modal window
                            body: {
                                view: 'scrollview', // Scrollable body
                                scroll: 'xy', // Enable both horizontal and vertical scrolling
                                body: {
                                    view: 'form', // Form for adding partner products
                                    id: 'addform', // ID for the add form
                                    width: screen.width < 500 ? 500 : 600, // Width based on screen size
                                    height: screen.width < 500 ? 900 : 900, // Height based on screen size
                                    elements: [
                                        // Form elements
                                        {
                                            margin: 10,
                                            cols: [
                                                {
                                                    view: 'combo', // Combo input for Product
                                                    labelPosition: 'top',
                                                    label: 'Productos', // Label for Product
                                                    name: 'Product', // Name for the input
                                                    options: {
                                                        body: {
                                                            dataFeed: function (text) {
                                                                var vthis = this; // Reference to the current context
                                                                if (
                                                                    text.length > 2 // Check if input length is greater than 2
                                                                ) {
                                                                    webix
                                                                        .ajax()
                                                                        .headers({
                                                                            'Content-type': 'application/json', // Set content type
                                                                        })
                                                                        .post(
                                                                            devConfig.geturlApi() +
                                                                                'es/Select/GamesCasinoSelect', // API endpoint
                                                                            '{"Filter":"' + text + '"}', // Request body
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    webix.message(
                                                                                        'Error! ', // Error message
                                                                                    );
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    var resp = JSON.parse(text); // Parse response
                                                                                    if (!resp.HasError) {
                                                                                        vthis.parse(resp.Data); // Parse data into the combo
                                                                                    }
                                                                                },
                                                                            },
                                                                        );
                                                                }
                                                            },
                                                        },
                                                    },
                                                },
                                            ],
                                        },
                                        {
                                            margin: 10,
                                            cols: [
                                                {
                                                    view: 'combo', // Combo input for IsActivate
                                                    labelPosition: 'top',
                                                    label: _('Estado'), // Label with localization
                                                    name: 'IsActivate', // Name for the input
                                                    options: [
                                                        // Options for the combo
                                                        {
                                                            id: 'A',
                                                            value: _(
                                                                'Activado', // Active option
                                                            ),
                                                        },
                                                        {
                                                            id: 'I',
                                                            value: _(
                                                                'Inactivado', // Inactive option
                                                            ),
                                                        },
                                                    ],
                                                },
                                                {
                                                    view: 'combo', // Combo input for IsVerified
                                                    labelPosition: 'top',
                                                    label: _('Verificado'), // Label with localization
                                                    name: 'IsVerified', // Name for the input
                                                    options: [
                                                        // Options for the combo
                                                        {
                                                            id: 'A',
                                                            value: _(
                                                                'Activado', // Active option
                                                            ),
                                                        },
                                                        {
                                                            id: 'I',
                                                            value: _(
                                                                'Inactivado', // Inactive option
                                                            ),
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                        {
                                            margin: 10,
                                            cols: [
                                                {
                                                    view: 'combo', // Combo input for FilterCountry
                                                    labelPosition: 'top',
                                                    label: _('Filtro País'), // Label with localization
                                                    name: 'FilterCountry', // Name for the input
                                                    options: [
                                                        // Options for the combo
                                                        {
                                                            id: 'A',
                                                            value: _(
                                                                'Activado', // Active option
                                                            ),
                                                        },
                                                        {
                                                            id: 'I',
                                                            value: _(
                                                                'Inactivado', // Inactive option
                                                            ),
                                                        },
                                                    ],
                                                },
                                                {
                                                    view: 'text', // Text input for Processing Time
                                                    labelPosition: 'top',
                                                    label: _(
                                                        'Tiempo Procesamiento', // Label with localization
                                                    ),
                                                    name: 'ProcessingTime', // Name for the input
                                                    labelWidth: 160, // Label width
                                                },
                                            ],
                                        },
                                        {
                                            margin: 10,
                                            cols: [
                                                {
                                                    view: 'text', // Text input for Maximum
                                                    labelPosition: 'top',
                                                    label: _('Máximo'), // Label with localization
                                                    name: 'Maximum', // Name for the input
                                                    attributes: {
                                                        type: 'number', // Input type
                                                    },
                                                },
                                                {
                                                    view: 'text', // Text input for Minimum
                                                    labelPosition: 'top',
                                                    label: _('Mínimo'), // Label with localization
                                                    name: 'Minimum', // Name for the input
                                                    attributes: {
                                                        type: 'number', // Input type
                                                    },
                                                },
                                            ],
                                        },
                                        {
                                            margin: 10,
                                            cols: [
                                                {
                                                    view: 'text', // Text input for Order
                                                    labelPosition: 'top',
                                                    label: _('Orden'), // Label with localization
                                                    name: 'Order', // Name for the input
                                                    attributes: {
                                                        type: 'number', // Input type
                                                    },
                                                },
                                                {
                                                    view: 'text', // Text input for FeaturedOrder
                                                    labelPosition: 'top',
                                                    label: _('Orden Destacado'), // Label with localization
                                                    name: 'FeaturedOrder', // Name for the input
                                                    labelWidth: 160, // Label width
                                                    attributes: {
                                                        type: 'number', // Input type
                                                    },
                                                },
                                                {
                                                    view: 'text', // Text input for Rows
                                                    labelPosition: 'top',
                                                    label: _('Filas'), // Label with localization
                                                    name: 'Rows', // Name for the input
                                                    labelWidth: 160, // Label width
                                                    attributes: {
                                                        type: 'number', // Input type
                                                    },
                                                },
                                                {
                                                    view: 'text', // Text input for Columns
                                                    labelPosition: 'top',
                                                    label: _('Columnas'), // Label with localization
                                                    name: 'Columns', // Name for the input
                                                    labelWidth: 160, // Label width
                                                    attributes: {
                                                        type: 'number', // Input type
                                                    },
                                                },
                                            ],
                                        },
                                        {
                                            view: 'forminput', // Double list input for Partners Add
                                            body: {
                                                view: 'dbllist', // Double list view
                                                id: 'dblPartnersAdd', // ID for the double list
                                                list: {
                                                    height: 200, // Height of the list
                                                    scroll: true, // Enable scrolling
                                                },
                                                labelLeft: _('Partners'), // Label for left list
                                                labelRight: _(
                                                    'Partners Seleccionados', // Label for right list
                                                ),
                                                data: profile.Partners, // Data for the list
                                            },
                                            labelWidth: 140, // Label width
                                            labelAlign: 'right', // Label alignment
                                        },
                                        {
                                            view: 'forminput', // Double list input for Categories Add
                                            body: {
                                                view: 'dbllist', // Double list view
                                                id: 'dbllistAdd', // ID for the double list
                                                list: {
                                                    height: 200, // Height of the list
                                                    scroll: true, // Enable scrolling
                                                },
                                                labelLeft: _('Categorías'), // Label for left list
                                                labelRight: _(
                                                    'Categorías Producto Partner', // Label for right list
                                                ),
                                                data: optionsCategorias, // Data for the list
                                            },
                                            labelWidth: 140, // Label width
                                            labelAlign: 'right', // Label alignment
                                        },
                                        {
                                            cols: [
                                                {
                                                    view: 'button', // Cancel button
                                                    value: _('Cancelar'), // Button label with localization
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Hide the window on cancel
                                                        $$('addform').clear(); // Clear the add form
                                                    },
                                                },
                                                {
                                                    view: 'button', // Save button
                                                    type: 'form', // Button type
                                                    value: _('Guardar'), // Button label with localization
                                                    click: function ($e) {
                                                        var values = $$('addform').getValues(); // Get values from the add form
                                                        var c2this = this; // Reference to the current context
                                                        values.Partners = arrayPartnersAdd; // Set partners in values
                                                        arrayPartnersWithoutAdd = []; // Initialize array for partners without addition
                                                        for (var i = 0; i < profile.Partners.length; i++) {
                                                            var flagPartners = false; // Flag for partner existence
                                                            for (
                                                                var j = 0;
                                                                (j < arrayPartnersAdd.length) & !flagPartners;
                                                                j++
                                                            ) {
                                                                if (profile.Partners[i].id == arrayPartnersAdd[j])
                                                                    flagPartners = true; // Set flag if partner exists
                                                            }
                                                            if (!flagPartners)
                                                                arrayPartnersWithoutAdd.push(
                                                                    profile.Partners[i].id, // Add to partners without addition
                                                                );
                                                        }
                                                        values.PartnersWithoutAdd = arrayPartnersWithoutAdd; // Set partners without addition
                                                        values.CategoriesAdd = arrayAdd; // Set categories to add
                                                        arrayWithoutAdd = []; // Initialize array for categories without addition
                                                        for (var i = 0; i < optionsCategorias.length; i++) {
                                                            var flag = false; // Flag for category existence
                                                            for (var j = 0; (j < arrayAdd.length) & !flag; j++) {
                                                                if (optionsCategorias[i].Id == arrayAdd[j]) flag = true; // Set flag if category exists
                                                            }
                                                            if (!flag)
                                                                arrayWithoutAdd.push(
                                                                    optionsCategorias[i].Id, // Add to categories without addition
                                                                );
                                                        }
                                                        values.CategoriesWithoutAdd = arrayWithoutAdd; // Set categories without addition
                                                        values.Partner = id_partner; // Set partner ID

                                                        // AJAX request to create partner product
                                                        webix
                                                            .ajax()
                                                            .headers({
                                                                'Content-type': 'application/json', // Set content type
                                                            })
                                                            .post(
                                                                devConfig.geturlApi() +
                                                                    'PartnerProduct/CreatePartnerProduct', // API endpoint
                                                                values, // Request body
                                                                {
                                                                    error: function (text, data, XmlHttpRequest) {
                                                                        webix.message(
                                                                            'Error! ', // Error message
                                                                        );
                                                                    },
                                                                    success: function (text, data, XmlHttpRequest) {
                                                                        text = JSON.parse(text); // Parse response
                                                                        if (text.HasError) {
                                                                            webix.message(
                                                                                'Error: ' + text.AlertMessage, // Error message with alert
                                                                            );
                                                                        } else {
                                                                            $$('addform').clear(); // Clear the add form
                                                                            c2this.getTopParentView().hide(); // Hide the window after saving
                                                                            webix.message(
                                                                                'Producto Partner Agregado', // Success message
                                                                            );
                                                                        }
                                                                    },
                                                                },
                                                            );
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            },
                        });
                        $$('dbllistAdd').attachEvent('onChange', function (id, e, node) {
                            if ($$('dbllistAdd').getValue() != '') {
                                arrayAdd = $$('dbllistAdd').getValue().split(','); // Split selected categories into array
                            } else {
                                arrayAdd = []; // Reset array if no selection
                            }
                        });
                        $$('dblPartnersAdd').attachEvent('onChange', function (id, e, node) {
                            if ($$('dblPartnersAdd').getValue() != '') {
                                arrayPartnersAdd = $$('dblPartnersAdd').getValue().split(','); // Split selected partners into array
                            } else {
                                arrayPartnersAdd = []; // Reset array if no selection
                            }
                        });
                    },
                },
            );
        this.on(this.app, 'changePartnetsEdit', (filter) => {
            if ($$('dblPartnersEdit').getValue() != '') {
                arrayPartnersEdit = $$('dblPartnersEdit').getValue().split(','); // Split selected partners into array
            } else {
                arrayPartnersEdit = []; // Reset array if no selection
            }
        });
        this.on(this.app, 'changeCategoriesEdit', (filter) => {
            if ($$('dbllistEdit').getValue() != '') {
                arrayAddEdit = $$('dbllistEdit').getValue().split(','); // Split selected categories into array
            } else {
                arrayAddEdit = []; // Reset array if no selection
            }
        });
        this.on(this.app, 'addProductPartner:button', (filter) => {
            if (optionsCategorias.length > 0 && products.length > 0) {
                $$('addform').clearValidation(); // Clear validation on add form
                popupAdd.show(); // Show add popup
                var optionsCountries = $$('AddProduct').getList(); // Get list of countries
                optionsCountries.clearAll(); // Clear existing options
                optionsCountries.parse(products); // Parse products into the list
            } else {
                webix.message({
                    text: _('Datos no han podido ser cargados'), // Error message
                    title: _('¡Error!'), // Error title
                    type: 'alert-error', // Error type
                });
            }
        });
        this.on(this.app, 'partnerProducts:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to string
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to filter string
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to filter string
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format dateFrom
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format dateTo
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Add partner ID to filter string
            grid.clearAll(); // Clear the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load grid data with filters
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger event with user ID
        });
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load grid data with player ID
            );
        });
        grid.attachEvent('onItemDblClick', function (id, e, node) {
            var item = this.getItem(id); // Get double-clicked item
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load grid data after sorting
            );
        });
        // AJAX request to fetch products
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(
                devConfig.geturlApi() + 'Report/GetProducts', // API endpoint
                '{"Partner":"' + id_partner + '"}', // Request body
                {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Error message
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var data = JSON.parse(
                            text
                                .replace(/"Id"/g, '"id"') // Normalize Id field
                                .replace(/"Name"/g, '"value"'), // Normalize Name field
                        );
                        console.log(data); // Log data
                        products = data.Data; // Set products data
                    },
                },
            );
    }
}

// FILE DOCUMENTED
